// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_login__jJiFM {
  display: flex;
  background: var(--background-primary);
}
.Login_login_image__j3UH0 {
  width: 55%;
  overflow-y: hidden;
  height: 100vh;
}
.Login_login_image__j3UH0 img {
  height: 100vh;
  width: 100%;
}
.Login_login_textBox__HUCh4 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  width: 310px;
  overflow-y: auto;
  padding-top: 15px;
  padding-bottom: 15px;
}
.Login_login_text__cVIg5 {
  width: 100%;
}
.Login_login_join__jb6ba {
  color: var(--text-link);
  margin-bottom: 5px;
  font-size: 22px;
  font-weight: 600;
}
.Login_login_doMore__nvSMb {
  color: var(--text-secondary);
  margin-bottom: 40px;
  font-size: 14px;
}
.Login_login_continueRingplan__91c2D {
  display: flex;
  width: 100%;
  padding: 11px 12px;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--border-primary);
  margin-bottom: 25px;
}
.Login_login_continueRingplan__91c2D img {
  width: 25px;
}
.Login_login_continueRingplan__91c2D span {
  display: inline-block;
  width: 100%;
  text-align: center;
}
.Login_login_inputBox__E7kdV {
  margin-bottom: 12px;
  position: relative;
}
.Login_login_inputBox_error__b3dLM {
  color: var(--text-danger, #ee3939);
  height: 17px;
  padding: 0 10px;
}
.Login_login_inputBox__E7kdV input {
  display: flex;
  width: 100%;
  height: 40px;
  padding: 11px 30px 11px 30px;
  align-items: center;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid var(--border-secondary);
  background: var(--background-tertiary);
}
.Login_login_inputBox__E7kdV input::placeholder {
  color: var(--text-tertiary);
}
.Login_login_inputBox__E7kdV svg {
  position: absolute;
  top: 35%;
  left: 10px;
  transform: translateY(-50%);
}
.Login_login_signIn__-W6iR {
  display: flex;
  width: 100%;
  padding: 11px 12px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: var(--primary-default);
  color: var(--text-on-color);
  cursor: pointer;
  margin-top: 30px;
}

.Login_or__\\+Z8hG {
  text-align: center;
  margin-top: 15px;
  margin-bottom: 10px;
  color: var(--text-secondary);
}

.Login_continueRingplan__8Vs9t img {
  width: 25px;
}
.Login_continueRingplan__8Vs9t span {
  display: inline-block;
  width: 100%;
  text-align: center;
  color: var(--text-primary);
}

.Login_loginWithExtension_toggle__eyzdh {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  color: var(--text-secondary);
  margin-bottom: 20px;
  font-size: 13px;
  transition: color 0.3s;
}
.Login_loginWithExtension_toggle__eyzdh:hover {
  color: var(--text-primary);
}
.Login_loginWithExtension_chevronDown__jALC4, .Login_loginWithExtension_chevronUp__NXQxf {
  background: var(--background-quaternary);
  height: 22px;
  width: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 0 !important;
  border-radius: 100%;
}
.Login_loginWithExtension_chevronDown__jALC4 svg, .Login_loginWithExtension_chevronUp__NXQxf svg {
  width: 13px;
}
.Login_loginWithExtension__naacN .Login_btn__qKtI9 button {
  width: 100%;
}

.Login_userEmail__Xu4j2 {
  margin-bottom: 15px;
}
.Login_userEmail__Xu4j2 label {
  font-size: 0.95em;
  color: var(--text-secondary);
  margin-bottom: 5px;
  display: flex;
  text-align: left;
}
.Login_userEmail__Xu4j2 label span {
  margin-left: 7px;
  text-align: left;
  font-size: 0.7em;
  color: var(--text-tertiary);
}
.Login_userEmail__Xu4j2 input {
  border: 1px solid var(--border-primary);
  border-radius: 7px;
  width: 100%;
  padding: 12px 15px;
}

.Login_userEmailError__QkMis {
  color: var(--text-danger);
  font-size: 0.75em;
  margin-top: 8px;
}

.Login_mulAcct__FqiXj {
  margin-top: -10px;
}
.Login_mulAcct__FqiXj > p {
  color: var(--text-secondary);
  font-size: 0.8em;
  display: flex;
  align-items: stretch;
}
.Login_mulAcct__FqiXj > p button {
  display: flex;
  align-items: center;
  margin-right: 10px;
  border: 1px solid var(--border-secondary);
  padding: 0 4px;
  border-radius: 2px;
}
.Login_mulAcct__FqiXj > p button svg {
  width: 18px;
  height: 18px;
}
.Login_mulAcct__FqiXj > div button {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.Login_mulAcct__FqiXj > div button > div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.Login_mulAcct__FqiXj > div button h3 {
  color: var(--text-primary);
  font-size: 0.95em;
  text-align: left;
}
.Login_mulAcct__FqiXj > div button span {
  color: var(--text-secondary);
  font-size: 0.9em;
  text-align: left;
}

@media screen and (max-width: 1200px) {
  .Login_login__jJiFM {
    min-height: 100vh;
  }
  .Login_login_image__j3UH0 {
    display: none;
  }
}
@media only screen and (max-width: 320px) {
  .Login_login_textBox__HUCh4 {
    width: 100%;
    padding: 0 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,qCAAA;AACD;AACC;EACC,UAAA;EACA,kBAAA;EACA,aAAA;AACF;AACE;EACC,aAAA;EACA,WAAA;AACH;AAGC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AADF;AAIC;EACC,WAAA;AAFF;AAKC;EACC,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAHF;AAMC;EACC,4BAAA;EACA,mBAAA;EACA,eAAA;AAJF;AAOC;EACC,aAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uCAAA;EACA,mBAAA;AALF;AAOE;EACC,WAAA;AALH;AAQE;EACC,qBAAA;EACA,WAAA;EACA,kBAAA;AANH;AAUC;EACC,mBAAA;EACA,kBAAA;AARF;AAUE;EACC,kCAAA;EACA,YAAA;EACA,eAAA;AARH;AAWE;EACC,aAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,yCAAA;EACA,sCAAA;AATH;AAWG;EACC,2BAAA;AATJ;AAaE;EACC,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;AAXH;AAeC;EACC,aAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,kCAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;AAdF;;AAkBA;EACC,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;AAfD;;AAmBC;EACC,WAAA;AAhBF;AAmBC;EACC,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,0BAAA;AAjBF;;AAsBC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EAEA,sBAAA;AApBF;AAsBE;EACC,0BAAA;AApBH;AAwBC;EAEC,wCAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,mBAAA;AAvBF;AAwBE;EACC,WAAA;AAtBH;AA2BE;EACC,WAAA;AAzBH;;AA8BA;EACC,mBAAA;AA3BD;AA6BC;EACC,iBAAA;EACA,4BAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AA3BF;AA6BE;EACC,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;AA3BH;AA+BC;EACC,uCAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AA7BF;;AAiCA;EACC,yBAAA;EACA,iBAAA;EACA,eAAA;AA9BD;;AAiCA;EACC,iBAAA;AA9BD;AAgCC;EACC,4BAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;AA9BF;AAgCE;EACC,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;EACA,cAAA;EACA,kBAAA;AA9BH;AAgCG;EACC,WAAA;EACA,YAAA;AA9BJ;AAoCE;EACC,gBAAA;EACA,aAAA;EACA,8BAAA;AAlCH;AAoCG;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;AAlCJ;AAqCG;EACC,0BAAA;EACA,iBAAA;EACA,gBAAA;AAnCJ;AAsCG;EACC,4BAAA;EACA,gBAAA;EACA,gBAAA;AApCJ;;AA0CA;EACC;IACC,iBAAA;EAvCA;EAyCA;IACC,aAAA;EAvCD;AACF;AA2CA;EACC;IACC,WAAA;IACA,eAAA;EAzCA;AACF","sourcesContent":[".login {\n\tdisplay: flex;\n\tbackground: var(--background-primary);\n\n\t&_image {\n\t\twidth: 55%;\n\t\toverflow-y: hidden;\n\t\theight: 100vh;\n\n\t\t& img {\n\t\t\theight: 100vh;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t&_textBox {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tmargin: auto;\n\t\twidth: 310px;\n\t\toverflow-y: auto;\n\t\tpadding-top: 15px;\n\t\tpadding-bottom: 15px;\n\t}\n\n\t&_text {\n\t\twidth: 100%;\n\t}\n\n\t&_join {\n\t\tcolor: var(--text-link);\n\t\tmargin-bottom: 5px;\n\t\tfont-size: 22px;\n\t\tfont-weight: 600;\n\t}\n\n\t&_doMore {\n\t\tcolor: var(--text-secondary);\n\t\tmargin-bottom: 40px;\n\t\tfont-size: 14px;\n\t}\n\n\t&_continueRingplan {\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t\tpadding: 11px 12px;\n\t\talign-items: center;\n\t\tborder-radius: 8px;\n\t\tborder: 1px solid var(--border-primary);\n\t\tmargin-bottom: 25px;\n\n\t\t& img {\n\t\t\twidth: 25px;\n\t\t}\n\n\t\tspan {\n\t\t\tdisplay: inline-block;\n\t\t\twidth: 100%;\n\t\t\ttext-align: center;\n\t\t}\n\t}\n\n\t&_inputBox {\n\t\tmargin-bottom: 12px;\n\t\tposition: relative;\n\n\t\t&_error {\n\t\t\tcolor: var(--text-danger, #ee3939);\n\t\t\theight: 17px;\n\t\t\tpadding: 0 10px;\n\t\t}\n\n\t\t& input {\n\t\t\tdisplay: flex;\n\t\t\twidth: 100%;\n\t\t\theight: 40px;\n\t\t\tpadding: 11px 30px 11px 30px;\n\t\t\talign-items: center;\n\t\t\tflex-shrink: 0;\n\t\t\tborder-radius: 8px;\n\t\t\tborder: 1px solid var(--border-secondary);\n\t\t\tbackground: var(--background-tertiary);\n\n\t\t\t&::placeholder {\n\t\t\t\tcolor: var(--text-tertiary);\n\t\t\t}\n\t\t}\n\n\t\t& svg {\n\t\t\tposition: absolute;\n\t\t\ttop: 35%;\n\t\t\tleft: 10px;\n\t\t\ttransform: translateY(-50%);\n\t\t}\n\t}\n\n\t&_signIn {\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t\tpadding: 11px 12px;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\tborder-radius: 8px;\n\t\tbackground: var(--primary-default);\n\t\tcolor: var(--text-on-color);\n\t\tcursor: pointer;\n\t\tmargin-top: 30px;\n\t}\n}\n\n.or {\n\ttext-align: center;\n\tmargin-top: 15px;\n\tmargin-bottom: 10px;\n\tcolor: var(--text-secondary);\n}\n\n.continueRingplan {\n\timg {\n\t\twidth: 25px;\n\t}\n\n\tspan {\n\t\tdisplay: inline-block;\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--text-primary);\n\t}\n}\n\n.loginWithExtension {\n\t&_toggle {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tgap: 10px;\n\t\twidth: 100%;\n\t\tcolor: var(--text-secondary);\n\t\tmargin-bottom: 20px;\n\t\tfont-size: 13px;\n\n\t\ttransition: color 0.3s;\n\n\t\t&:hover {\n\t\t\tcolor: var(--text-primary);\n\t\t}\n\t}\n\n\t&_chevronDown,\n\t&_chevronUp {\n\t\tbackground: var(--background-quaternary);\n\t\theight: 22px;\n\t\twidth: 22px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tpadding-bottom: 0 !important;\n\t\tborder-radius: 100%;\n\t\tsvg {\n\t\t\twidth: 13px;\n\t\t}\n\t}\n\n\t.btn {\n\t\tbutton {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n\n.userEmail {\n\tmargin-bottom: 15px;\n\n\tlabel {\n\t\tfont-size: 0.95em;\n\t\tcolor: var(--text-secondary);\n\t\tmargin-bottom: 5px;\n\t\tdisplay: flex;\n\t\ttext-align: left;\n\n\t\tspan {\n\t\t\tmargin-left: 7px;\n\t\t\ttext-align: left;\n\t\t\tfont-size: 0.7em;\n\t\t\tcolor: var(--text-tertiary);\n\t\t}\n\t}\n\n\tinput {\n\t\tborder: 1px solid var(--border-primary);\n\t\tborder-radius: 7px;\n\t\twidth: 100%;\n\t\tpadding: 12px 15px;\n\t}\n}\n\n.userEmailError {\n\tcolor: var(--text-danger);\n\tfont-size: 0.75em;\n\tmargin-top: 8px;\n}\n\n.mulAcct {\n\tmargin-top: -10px;\n\n\t> p {\n\t\tcolor: var(--text-secondary);\n\t\tfont-size: 0.8em;\n\t\tdisplay: flex;\n\t\talign-items: stretch;\n\n\t\tbutton {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tmargin-right: 10px;\n\t\t\tborder: 1px solid var(--border-secondary);\n\t\t\tpadding: 0 4px;\n\t\t\tborder-radius: 2px;\n\n\t\t\tsvg {\n\t\t\t\twidth: 18px;\n\t\t\t\theight: 18px;\n\t\t\t}\n\t\t}\n\t}\n\n\t> div {\n\t\tbutton {\n\t\t\tmargin-top: 10px;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\n\t\t\t> div {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: flex-start;\n\t\t\t}\n\n\t\t\th3 {\n\t\t\t\tcolor: var(--text-primary);\n\t\t\t\tfont-size: 0.95em;\n\t\t\t\ttext-align: left;\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tcolor: var(--text-secondary);\n\t\t\t\tfont-size: 0.9em;\n\t\t\t\ttext-align: left;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media screen and (max-width: 1200px) {\n\t.login {\n\t\tmin-height: 100vh;\n\n\t\t&_image {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n@media only screen and (max-width: 320px) {\n\t.login_textBox {\n\t\twidth: 100%;\n\t\tpadding: 0 20px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login": `Login_login__jJiFM`,
	"login_image": `Login_login_image__j3UH0`,
	"login_textBox": `Login_login_textBox__HUCh4`,
	"login_text": `Login_login_text__cVIg5`,
	"login_join": `Login_login_join__jb6ba`,
	"login_doMore": `Login_login_doMore__nvSMb`,
	"login_continueRingplan": `Login_login_continueRingplan__91c2D`,
	"login_inputBox": `Login_login_inputBox__E7kdV`,
	"login_inputBox_error": `Login_login_inputBox_error__b3dLM`,
	"login_signIn": `Login_login_signIn__-W6iR`,
	"or": `Login_or__+Z8hG`,
	"continueRingplan": `Login_continueRingplan__8Vs9t`,
	"loginWithExtension_toggle": `Login_loginWithExtension_toggle__eyzdh`,
	"loginWithExtension_chevronDown": `Login_loginWithExtension_chevronDown__jALC4`,
	"loginWithExtension_chevronUp": `Login_loginWithExtension_chevronUp__NXQxf`,
	"loginWithExtension": `Login_loginWithExtension__naacN`,
	"btn": `Login_btn__qKtI9`,
	"userEmail": `Login_userEmail__Xu4j2`,
	"userEmailError": `Login_userEmailError__QkMis`,
	"mulAcct": `Login_mulAcct__FqiXj`
};
export default ___CSS_LOADER_EXPORT___;
